
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("iskSB", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $d6fb09ccb9896306$export$2cd8252107eb640b; });

var $2mpqL = parcelRequire("2mpqL");

var $5PBbn = parcelRequire("5PBbn");
var $d6fb09ccb9896306$export$2cd8252107eb640b = function init(callback) {
    var swiperContainers = document.querySelectorAll(".swiper-container.swiper-container--1");
    swiperContainers.forEach(function(swiperContainer) {
        var cID = swiperContainer.getAttribute("id");
        var id = swiperContainer.querySelector(".swiper").getAttribute("id");
        var swiper = new (0, $2mpqL.default)("#".concat(id), {
            modules: [
                (0, $5PBbn.Navigation),
                (0, $5PBbn.Keyboard),
                (0, $5PBbn.A11y)
            ],
            speed: 500,
            slidesPerView: 1,
            spaceBetween: 30,
            // setWrapperSize: true,
            loop: true,
            // centeredSlides: true,
            watchOverflow: true,
            navigation: {
                nextEl: "#".concat(cID, " .swiper-button-next"),
                prevEl: "#".concat(cID, " .swiper-button-prev")
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true
            },
            breakpoints: {
                576: {
                    spaceBetween: 30,
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                }
            },
            on: {
                afterInit: function afterInit() {
                    document.querySelector("#".concat(cID)).classList.add("slider-init");
                },
                update: function update(swiper) {
                    swiper.slideTo(1, 0);
                },
                lock: function lock() {
                    document.querySelector("#".concat(cID)).classList.add("slider-lock");
                },
                unlock: function unlock() {
                    document.querySelector("#".concat(cID)).classList.remove("slider-lock");
                }
            }
        });
        window.addEventListener("resize", function() {
            swiper.update();
        });
    });
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$71511d61b312f219; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d624443cd99befe$export$71511d61b312f219; });
function $3d624443cd99befe$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$71511d61b312f219; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=swiper1.module.7d637d1e.js.map
